module.exports = __webpack_public_path__ + "static/media/Laser-Care-Clinic.73657bef.png";